<template>
  <LoadingState v-if="isLoading()" :size="50" />
  <ErrorState v-else-if="isErrored()" />
  <div v-else-if="site" class="row">
    <div v-if="hasApp()" class="col-md-4">
      <Application :resource-name="getResourceName()" :site="site" />
    </div>
    <div :class="getClass()">
      <div class="row pb-4">
        <div class="col-md-12">
          <Php
            :resource-name="getResourceName()"
            :site="site"
            :site-status="siteStatus"
            class="mb-4"
          />
        </div>
      </div>
      <div v-if="site" class="row pb-4">
        <div class="col-md-12">
          <Redis :site="site" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Application from "@/components/smart/cards/Application";
import { computed } from "@vue/composition-api";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import Php from "@/components/smart/cards/Php";
import Redis from "@/components/smart/cards/Redis";
import store from "@/store";

export default {
  name: "PlanEnvironmentPage",
  components: {
    Application,
    ErrorState,
    LoadingState,
    Php,
    Redis,
  },
  setup() {
    const plan = computed(() => store.getters["plans/getItem"]);
    const planStatus = computed(() => store.getters["plans/getItemStatus"]);
    const site = computed(() => store.getters["plans/getPrimarySite"]);
    const siteStatus = computed(() => store.getters["plans/getPrimarySiteStatus"]);

    const getClass = () => (hasApp() ? "col-md-8" : "col-md-12");
    const getResourceName = () => plan.value?.nickname;

    const hasApp = () => !!site.value?.environment?.access?.url;

    const isErrored = () => planStatus.value.isErrored || siteStatus.value.isErrored;
    const isLoading = () => planStatus.value.isLoading || siteStatus.value.isLoading;

    return {
      getClass,
      getResourceName,
      hasApp,
      isErrored,
      isLoading,
      plan,
      site,
      siteStatus,
    };
  },
};
</script>
